import React, { Component } from "react";
import {
  EmailValidate,
  FormValidate,
} from "../../../../../components/formValidate";
import CustomButton from "../../../../../components/inputs/button";
import Snackbar from "../../../../../components/snackbar/snackbar";
import { user_event_booking } from "../../../../../pages/user/user.api";
import TextField from "../../../../inputs/textfield";
import Loader from "../../../../loader/loader";
import "./dialog.css";
import {
  public_event_bookstatus_details,
  public_event_details,
} from "../../../../../pages/public/public.api";

let required = [
  "full_name",
  "contact_no",
  "address",
  "email",
  // "designation",
  "event_registration_type_id",
  // "verification_document,",
];
let required1 = [
  "full_name",
  "contact_no",
  "address",
  "email",
  // "reference_no",
  // "paid_amount",
  // "designation",
  "event_registration_type_id",
  // "verification_document",
];

class BookingDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
      formData: {},
      edit: props.edit,
      submitted: false,
      snackMessage: "",
      snackId: "",
      emailError: false,
      isActive: false,
      isSnackError: false,
      snackOpen: false,
      event: props.event,
      paymentDetails: false,
      data: props.data,
    };
  }

  componentWillReceiveProps = (props) => {
    this.setState({
      open: props.open,
      edit: props.edit,
      formData: props.formData,
      event: props.event,
      data: props.data,
    });
  };
  handleChange = (e) => {
    let value = e.target.value;
    let name = e.target.name;
    if (e.target.name === "email") {
      let erroremail = !EmailValidate(e.target.value);

      this.setState({
        emailError: erroremail,
      });
    }
    this.setState({ formData: { ...this.state.formData, [name]: value } });
  };
  snackbarClose = (flag) => {
    this.setState({
      snackMessage: "",
      isSnackError: false,
      snackOpen: false,
      paymentDetails: true,
    });
    if (!flag) {
      this.props.handleClose();
    }
  };
  handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const sizeInMB = file.size / (1024 * 1024);
    const extension = file.name.split(".").pop().toLowerCase();

    if (extension === "pdf") {
      if (sizeInMB <= 5) {
        this.setState({
          fileChange: true,
          fileError: false,
          formData: {
            ...this.state.formData,
            verification_document: file,
          },
        });
      } else {
        this.setState({
          fileError: true,
          formData: {
            ...this.state.formData,
            verification_document: null,
          },
        });
      }
    } else {
      this.setState({
        fileError: true,
        formData: {
          ...this.state.formData,
          verification_document: null,
        },
      });
    }
  };

  handleSubmit = (e) => {
    const { emailError, event, formData, data, fileError } = this.state;
    let reqType = event.paid === "0" ? required : required1;
    const errors = FormValidate(formData, reqType);
    const { edit } = this.state;
    console.log(errors);
    console.log(formData);
    e.preventDefault();

    if (fileError || !formData.verification_document) {
      this.setState({
        submitted: false,
        snackMessage: "Please upload a valid PDF file under 5MB",
        isSnackError: true,
        snackOpen: true,
      });
      return;
    }

    if (Object.keys(errors).length === 0) {
      if (!emailError) {
        if (formData.contact_no.length === 10) {
          if (!formData.event_registration_type_id) {
            this.setState({
              submitted: false,
              snackMessage: "Please select a registration type",
              isSnackError: true,
              snackOpen: true,
            });
            return;
          }

          const selectedRegType = data?.en?.registration_types?.find(
            (type) =>
              String(type.id) === String(formData.event_registration_type_id)
          );

          if (selectedRegType) {
            localStorage.setItem(
              "amount",
              JSON.stringify(selectedRegType.fees)
            );
          }

          const dataToSubmit = new FormData();

          Object.keys(formData).forEach((key) => {
            const value = formData[key];
            if (key === "verification_document" && value instanceof File) {
              dataToSubmit.append("verification_document", value);
            } else if (value !== undefined && value !== null) {
              dataToSubmit.append(key, value);
            }
          });

          dataToSubmit.append("event_id", event.id);
          dataToSubmit.append(
            "registration_type",
            JSON.stringify(selectedRegType || {})
          );
          this.props.fees?.(selectedRegType);
          this.setState({ isActive: true, submitted: true });

          user_event_booking(dataToSubmit)
            .then((res) => {
              localStorage.setItem("booking_id", res.id);
              this.setState({
                submitted: true,
                isActive: false,
                snackMessage: res.message,
                snackId: res?.booking_id,
                isSnackError: false,
                snackOpen: true,
              });
            })
            .catch((error) => {
              this.setState({
                submitted: false,
                isActive: false,
                snackMessage: error.message,
                isSnackError: true,
                snackOpen: true,
              });
            });
        } else {
          this.setState({
            submitted: false,
            snackMessage: "Enter a valid 10 digit Contact Number",
            isSnackError: true,
            snackOpen: true,
          });
        }
      } else {
        this.setState({
          submitted: false,
          snackMessage: "Please enter a valid email address",
          isSnackError: true,
          snackOpen: true,
        });
      }
    } else {
      this.setState({
        submitted: false,
        snackMessage: "Please fill all mandatory fields",
        isSnackError: true,
        snackOpen: true,
      });
    }
  };

  handlePhoneNumberChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let newValue = value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
    this.setState({ formData: { ...this.state.formData, [name]: newValue } });
  };
  render() {
    const {
      submitted,
      Message,
      isActive,
      isError,
      open,
      formData,
      event,
      data,
    } = this.state;
    const validRegistrationTypes = data?.en?.registration_types?.filter(
      (type) => type.seat_limit >= 0
    );

    return (
      <React.Fragment>
        {open && (
          <React.Fragment>
            <div className="overlay">
              <div className="big-dia-book">
                <Snackbar
                  Booking_Id={this.state.snackId}
                  message={this.state.snackMessage}
                  error={this.state.isSnackError}
                  open={this.state.snackOpen}
                  close={this.snackbarClose}
                  setPayDialog={this.setPayDialog}
                  setBookId={this.setBookId}
                  handleOkClick={this.handleOkClick}
                />
                <Loader open={isActive} />
                <div className="row">
                  <div className="book-head">Registration of the event</div>
                  <div
                    className="dia-close"
                    onClick={this.props.bookingModalClose}
                  >
                    <div className="diaCloseCon">
                      <div className="diaClose">&#10005;</div>
                    </div>
                  </div>
                  <div className="tilebar-book">
                    <hr />
                  </div>
                  <form action="">
                    <div className="book-form">
                      <div className="col-12">
                        <TextField
                          id="outlined-basic"
                          label="Name"
                          variant="outlined"
                          onChange={(e) => this.handleChange(e)}
                          value={formData?.full_name ?? ""}
                          name="full_name"
                          required
                        />
                      </div>
                      <div className="col-12">
                        <TextField
                          id="outlined-basic"
                          label="Designation"
                          variant="outlined"
                          onChange={(e) => this.handleChange(e)}
                          value={formData?.designation ?? ""}
                          name="designation"
                        />
                      </div>
                      <div className="col-12">
                        <TextField
                          id="outlined-basic"
                          label="Organization / Academic Institution"
                          variant="outlined"
                          onChange={(e) => this.handleChange(e)}
                          value={formData?.address ?? ""}
                          name="address"
                          required
                        />
                      </div>
                      <div className="col-12">
                        <TextField
                          type="file"
                          id="outlined-basic"
                          onChange={this.handleFileChange}
                          label="Participant Details Document"
                          variant="outlined"
                          accept=".pdf"
                          file_name={formData?.verification_document}
                          required
                        />
                        {this.state.fileError && (
                          <div className="file-up-helper text-danger">
                            *Only PDF files under 5MB are allowed
                          </div>
                        )}
                      </div>
                      <div className="col-12">
                        <TextField
                          id="outlined-basic"
                          label="Email Id"
                          variant="outlined"
                          onChange={(e) => this.handleChange(e)}
                          value={formData?.email ?? ""}
                          name="email"
                          type="email"
                          // maxLength="11"
                          required
                        />
                      </div>

                      <div className="col-12">
                        <TextField
                          id="outlined-basic"
                          label="Mobile Number"
                          variant="outlined"
                          value={formData?.contact_no ?? ""}
                          name="contact_no"
                          required
                          maxLength="10"
                          minLength="10"
                          pattern="[0-9]{10}"
                          onChange={(e) => this.handlePhoneNumberChange(e)}
                          type="text"
                        />
                      </div>

                      {validRegistrationTypes?.length >= 0 && (
                        <div className="col-12">
                          <div className="fieldset">
                            <label className="mb-1 label-reg">
                              Registration Type
                            </label>
                            <select
                              className="form-select mandatory-select mt-2 "
                              aria-label="Default select example"
                              id="event_registration_type_id"
                              name="event_registration_type_id"
                              value={formData?.event_registration_type_id}
                              onChange={this.handleChange}
                              required
                            >
                              <option>Select registration type</option>
                              {validRegistrationTypes?.map((type) => (
                                <option key={type.id} value={type.id}>
                                  {`${type.type} (${type.days}) - Registration Amount ₹${type.fees}/-`}
                                  {/* {`${type.type} - Registration Amount ₹${type.fees}/-`} */}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      )}

                      <div className="col-12">
                        <CustomButton
                          label="Register"
                          disabled={submitted}
                          onClick={(e) => this.handleSubmit(e)}
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default BookingDialog;
